module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.11185/js/img/ContentHub_Icon.svg"